module.exports = __webpack_public_path__ + "13_hair_brown.c4378b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/13_hair_brown.png
// module id = C+UN
// module chunks = 0